const defaultState = {
  salesInsight: {
    summaryData: null,
    cityLevelData: null,
    cityLevelLoading: false,
    multipleLocalitiesData: null,
  },
};

const reducer = (state = defaultState, action) => {
  switch (action.type) {
    case "SUMMARY_INSIGHTS":
      return {
        ...state,
        salesInsight: {
          ...state.salesInsight,
          summaryData: action.summaryData,
        },
      };
    case "CITY_LEVEL_INSIGHTS_REQUEST":
      return {
        ...state,
        salesInsight: {
          ...state.salesInsight,
          cityLevelLoading: true,
        },
      };
    case "CITY_LEVEL_INSIGHTS":
      return {
        ...state,
        salesInsight: {
          ...state.salesInsight,
          cityLevelData: action.cityLevelData,
          cityLevelLoading: false,
        },
      };
    case "MULTIPLE_LOCALITIES_INSIGHTS":
      return {
        ...state,
        salesInsight: {
          ...state.salesInsight,
          multipleLocalitiesData: {
            ...state.salesInsight.multipleLocalitiesData,
            [action.serviceType]: action.multipleLocalitiesData,
          },
        },
      };
  }
};

export default reducer;
